module.exports = __webpack_public_path__ + "img/activehome.f6b560ef.svg";